<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Current Stock Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.selectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div> -->

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
              <!-- <label
                :class="getDistributorReportSelectedMovie && getDistributorReportSelectedMovie.length > 0 ? 'shift-up' : ''"
              >Select Movie</label>
              <b-dropdown
                :text="getDistributorReportSelectedMovie"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorReportMoviesList"
                  :key="dropdownIndex+dropdownItem.movie_title"
                  @click="onDistributorReportDropdownHandler({ event: $event, name:'isMovie',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.movie_title }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="Units"
                :searchable="true"
                :placeholder="filterValue.uom_unit"
                label="uom_unit"
                track-by="uom_id"
                v-model="filterValue"
                @input="searchInputData"
                :allowEmpty="false"
                :showLabels="false"
              >
              </multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="searchBarInput"
                  v-debounce:500="searchBarData"
                />
                <label>{{ $t("Search") }}</label>
              </div>
              <!--Tooltip :title="$t('itemname')" /-->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('itemname')">{{
                errors.first("itemname")
              }}</span>
            </p>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <b-form-checkbox
              id="checkbox-1"
              class="j-checkbox pb-0"
              @change="showNegativeFn()"
              v-model="showNegative"
              name="checkbox-1"
              value="Y"
              unchecked-value="N"
            >
              Show Negative
            </b-form-checkbox>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getBoxOfficeReceiptReport"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-12 align-self-center mb-2 d-flex justify-content-end align-items-center"
            v-if="getCurrentStockReport.length > 0"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
            <!-- <a
            
            :href="BASE_URL + getCurrentStockReportsExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a> -->
            <a href="#" @click="excelDownload()" title="Download as Excel">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            id="myTable"
            v-if="getCurrentStockReport.length > 0"
          >
            <thead class="bg-lightgrey font-weight-bold">
              <th class="text-left">{{ $t("location") }}</th>
              <th>{{ $tc("rawmaterials", 1) }} Id</th>
              <th>{{ $tc("rawmaterials", 1) }} {{ $t("name") }}</th>
              <th>{{ $t("system") }} {{ $t("stock") }}</th>
              <th>{{ $t("units") }}</th>

              <th>{{ $t("rate") }}</th>
              <th>{{ $t("value") }}</th>
            </thead>
            <tbody>
              <template v-for="(stock, stockIndex) in getCurrentStockReport">
                <tr :key="stockIndex + 'row1'">
                  <td :rowspan="stock.RawMaterials.length + 1" class="vertical_align">
                    <span>{{ stock.sm_store_name }}</span>
                  </td>
                </tr>

                <template
                  v-for="(rawMaterial, rawMaterialIndex) in stock.RawMaterials"
                >
                  <tr :key="rawMaterialIndex + 'row-2'">
                    <td class="text-left">
                      {{ rawMaterial.rm_code }}
                    </td>
                    <td class="text-left">
                      {{ rawMaterial.rm_name }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(rawMaterial.system_stock) }}
                    </td>
                    <td class="text-left">
                      {{ rawMaterial.uom_unit }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(parseFloat(rawMaterial.single_rate)) }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(parseFloat(
                          rawMaterial.system_stock * rawMaterial.single_rate
                        ))
                      }}
                    </td>
                  </tr>
                </template>
                <template v-if="showNegative == 'N'">
                  <tr
                    :key="rawMaterialIndex + 'grandTotal'"
                    class="bg-lightgrey font-weight-bold"
                  >
                    <td colspan="3">Total</td>
                    <td class="text-right">
                      {{
                        currFormat(stock.RawMaterials.reduce((acc, { system_stock }) => {
                          return acc + system_stock;
                        }, 0))
                      }}
                    </td>
                    <td></td>
                    <td></td>
                    <td class="text-right">
                      {{
                        currFormat(stock.RawMaterials.reduce(
                          (acc, { system_stock, single_rate }) => {
                            return acc + system_stock * single_rate;
                          },
                          0
                        ))
                      }}
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <table
        class="swc-report-table swc_table_header"
        border="1"
        v-if="getCurrentStockReport.length == 0"
      >
        <thead class="bg-lightgrey font-weight-bold">
          <th class="text-left">{{ $t("location") }}</th>
          <th>{{ $tc("rawmaterials", 1) }} Id</th>
          <th>{{ $tc("rawmaterials", 1) }} {{ $t("name") }}</th>
          <th>{{ $t("system") }} {{ $t("stock") }}</th>
          <th>{{ $t("units") }}</th>

          <th>{{ $t("rate") }}</th>
          <th>{{ $t("value") }}</th>
        </thead>
        <tbody>
          <tr>
            <td colspan="7">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import FnBReportService from "@/services/FnBReportsService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    NoRecords
  },
  computed: {
    //      ...mapGetters([
    //  "getCinemasList",
    //     "getRecipeReportsSelectedCinema",
    //     "getCurrentStockReports",
    //     // EXCEL
    //     "getCurrentStockReportsExcelFileName",
    //     // PDF
    //     "getCurrentStockReportsPDFFileName"
    //   ]),
  },
  data() {
    return {
      searchBarInput: "",
      searchValue: "",
      // newSearchplaceholder:"Search",
      filterValue: {
        uom_id: "0",
        uom_unit: "All",
        uom_short_form: "All",
        name: ""
      },
      Units: [
        {
          uom_id: "0",
          uom_unit: "All",
          uom_short_form: "All"
        }
      ],
      showNegative: "Y",
      showNegativeWatchers: "Y",
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      fromDate: new Date(),
      toDate: new Date(),
      getBoxOfficeReport: [],
      getCurrentStockReport: [],
      getCurrentStockReportMainData: [],
      Rawmaterial: [],
      getBoxOfficeFnBReport: [],
      getPaymentArray: []
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
    this.getUomList();
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
        this.onCurrentStockDropDownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj
        });
      }
    },
    showNegative: function(val) {
      this.getBoxOfficeReceiptReport();
    }
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onCurrentStockDropDownHandler({
        event: null,
        name: "isCinema",
        selectedItem: CinemaObj
      });
    }
  },

  methods: {
    //   searchFilter(){
    //   let filter =document.getElementById('my_Input').value.toUpperCase();
    //   let myTable= document.getElementById('myTable');
    //   let tr = myTable.getElementsByTagName('tr');

    //   for(vari=0;i<tr.length;i++){
    //       let td = tr[i].getElementsByTagName('td')[0]
    //    if(td){
    //   let textvlaue=td.textContent || td.innerHTML;

    //   if(textvlaue.toUpperCase().indexOf(filter) > -1){
    //        tr[i].style.display="";

    //   }
    //   else
    //   {
    //      tr[i].style.display="none";
    //   }
    //  }
    //   }
    //   },
    searchInputData(event) {
      this.getBoxOfficeReceiptReport();
    },
    searchBarData() {
      this.getBoxOfficeReceiptReport();
    },
    getUomList() {
      let payload = {
        tableName: "ms_unit_of_measurement"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            data.Records.map(x => {
              this.Units = [...this.Units, x];
            });

            // let findIndexDta=this.Units.findIndex(z=>{
            //   return z.uom_id==0;
            // })
            // if(findIndexDta<0){
            //  this.Units=[{uom_id=0,uom_name:""},...this.Units]
            // }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(() => {
          this.$toasted.show("Error");
        });
    },
    getCinemaList: function() {
      MasterService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
            //  this.Cinemas.map(x => {
            //   if (String(cine_id) === String(x.cine_id)) {
            //     // let cinema = {
            //     //   cine_name: x.cine_name,
            //     //   cine_id: x.cine_id
            //     // };

            //     // this.onSelectCinema(null,cinema);

            //     // this.onCurrentStockDropDownHandler({
            //     //   name: "isCinema",
            //     //   selectedItem: {
            //     //     cine_name: x.cine_name,
            //     //     cine_id: x.cine_id
            //     //   }
            //     // });
            //   }
            // });
            // if(this.CinemasCopy.cine_name.length == 0){
            // this.$toasted.show("Select Cinema");
            // }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    showNegativeFn() {
      return;
      this.showNegativeWatchers = this.showNegative;
      this.getBoxOfficeReceiptReport();
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getBoxOfficeReceiptReport: function() {
      let loader = this.$loading.show();
      this.submitted = true;
      this.getCurrentStockReport = [];
      this.getCurrentStockReportMainData = [];
      // this.getBoxOfficeFnBReport = [];
      this.getUomList();

      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        searchWord: this.searchBarInput ? this.searchBarInput : "",
        filterValue:
          this.filterValue.uom_unit == "All"
            ? ""
            : this.filterValue.uom_unit || ""
        // from_date: moment(this.fromDate).format("YYYY-MM-DD"),
        // to_date: moment(this.toDate).format("YYYY-MM-DD")
      };

      FnBReportService.GetCurrentStockReport(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            // console.log("data from api", data.Records);

            // this.getCurrentStockReportMainData=data.Records;
            this.getCurrentStockReport = data.Records;
            // console.log(storeArr);

            this.getCurrentStockReport.map(x => {
              x.RawMaterials.map(y => {
                x["sm_store_name"] = y.sm_store_name;
              });
            });

            if (this.getCurrentStockReport && this.showNegative == "N") {
              this.getCurrentStockReport.map((x, index) => {
                let arr = x.RawMaterials.filter(y => {
                  return y.system_stock > 0;
                });
                console.log(arr, "arr_test");
                this.getCurrentStockReport[index]["RawMaterials"] = arr;
              });
            } else {
              this.getCurrentStockReport = data.Records;
            }

            console.log(this.getCurrentStockReport, "dhcashcb");
          } else {
            this.$toasted.show(data.message);
          }
        })

        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },
    excelDownload() {
      //  let temp_arr = [];
      // new_records.map(x => {
      //   x.fnb_Records.map(y => {
      //     let obj = {
      //       ...x,
      //       ...y
      //     };
      //     temp_arr.push(obj);
      //   });
      // });
      // console.log({temp_arr})

      let temp_data = this.getCurrentStockReport;

      let temp_arr = [];
      temp_data.map(x => {
        x.RawMaterials.map(y => {
          x["cinema_name"] = this.dropDown.selectedCinemaName;
          let obj = {
            ...x,
            ...y
          };
          temp_arr.push(obj);
        });
      });
      console.log({ temp_arr });
      // let temp_arr = this.getBoxOfficeReport;
      // temp_arr = this.getBoxOfficeReport.map(x => {
      // x.paymentData.map(z => {
      // let obj = {
      // ...x,
      // ...z
      // };
      // new_records.push(obj);
      // });
      // });
      // let temp_arr_fnb = this.getBoxOfficeFnBReport.map(p => {
      // p["booking_source"] = "FNB";
      // new_records.push(p);
      // });
      // console.log("new_records", new_records);
      let data = [
        {
          sheet: "Current Stock Report",
          columns: [
            {
              value: "cinema_name",
              label: "Cinema Name"
            },
            {
              value: "sm_store_name",
              label: "Location"
            },
            {
              value: "rm_code",
              label: "Raw Material Id"
            },
            {
              value:"rm_name",
              label:"Raw Material Name"
            },
            {
              value: "system_stock",
              label: "System Stock"
            },
            {
              value: "uom_unit",
              label: "Units"
            },
            {
              value: row =>
                row.single_rate ? +parseFloat(row.single_rate).toFixed(2) : 0,
              label: "Rate"
            },
            {
              value: row =>
                row.system_stock && row.single_rate
                  ? +parseFloat(row.system_stock * row.single_rate).toFixed(2)
                  : 0,
              label: "Value"
            }
          ],
          content: temp_arr
        }
      ];
      let settings = {
        fileName: `CurrentStockReport${new Date().getTime()}`
      };
      xlsx(data, settings);
    }
  }
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.vertical_align{
  vertical-align: top;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/currentStockReport.vue